import { jsxs, jsx } from "react/jsx-runtime";
import { c as classNames } from "../../../../index-e71f83b5.js";
import FlashButton from "../../buttons/FlashButton/FlashButton.js";
import { useWindowSize } from "../../../../hooks/useWindowSize/useWindowSize.js";
import { sass } from "../../../../sass/sass.js";
import { noOp } from "../../../../utils/noOp.js";
import { u as useTranslation } from "../../../../useTranslation-cf39c293.js";
import { s as setToString, o as overRest, i as identity, k as keysIn } from "../../../../keysIn-f10bd97a.js";
import { i as isArrayLike, a as isIndex, e as eq } from "../../../../_arrayLikeKeys-44b287e6.js";
import { a as isObject } from "../../../../isObject-ec23ace2.js";
import "../../../../_commonjsHelpers-0c53d963.js";
import "react";
import "../../../constants.js";
import "../../info/FlashBadge/FlashBadge.js";
import "../../../../utils-f8d1c624.js";
import "../../info/FlashSpinner/FlashSpinner.js";
import "../../buttons/FlashButtonGeneric.js";
import "../../../../index-5e4e4f4b.js";
import "../../../../axios-5f69b112.js";
import "../../../../Button-9f0631d3.js";
import "../../../../hooks/useInsights/useInsights.js";
import "../../../../hooks/useLogger/constants.js";
import "../../../../hooks/useLogger/useLogger.js";
import "../../../../hooks/useLogger/LoggerContext.js";
import "../../../../hooks/useLogger/types.js";
import "../../../../hooks/useInsights/InsightsContext.js";
import "../../../../hooks/useInsights/useInsightsImpression.js";
import "../../../../index-2d889c01.js";
import "../../../../hooks/useInsights/utils.js";
import "../../../../utils/invokeFn.js";
import "../../buttons/FlashButton/constants.js";
import "../../../../hooks/useWindowSize/WindowSizeContext.js";
import "../../../../isSymbol-c6f5cd95.js";
import "../../../../i18nInstance-89725fcb.js";
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + "");
}
function isIterateeCall(value, index, object) {
  if (!isObject(object))
    return !1;
  var type = typeof index;
  return (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) ? eq(object[index], value) : !1;
}
var objectProto = Object.prototype, hasOwnProperty = objectProto.hasOwnProperty, defaults = baseRest(function(object, sources) {
  object = Object(object);
  var index = -1, length = sources.length, guard = length > 2 ? sources[2] : void 0;
  for (guard && isIterateeCall(sources[0], sources[1], guard) && (length = 1); ++index < length; )
    for (var source = sources[index], props = keysIn(source), propsIndex = -1, propsLength = props.length; ++propsIndex < propsLength; ) {
      var key = props[propsIndex], value = object[key];
      (value === void 0 || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) && (object[key] = source[key]);
    }
  return object;
});
const defaults$1 = defaults;
function FlashModalTitle(props) {
  const { title, Icon } = props, { windowIsMobile } = useWindowSize();
  return /* @__PURE__ */ jsxs("div", { className: "d-flex gap-flashd-013 align-items-center", children: [
    Icon && windowIsMobile && /* @__PURE__ */ jsx("span", { className: "ms-n2", children: /* @__PURE__ */ jsx(
      Icon,
      {
        height: sass.typography.flash.semantic.font.heading.xl3.size,
        width: sass.typography.flash.semantic.font.heading.xl3.size
      }
    ) }),
    title && /* @__PURE__ */ jsx("h2", { className: "fs-body-l fw-bold mb-n1", children: title })
  ] });
}
function FlashModalHorizontalRule(props) {
  const { windowIsMobile } = useWindowSize(), defaultMargin = windowIsMobile ? "3" : "4", { marginTop = defaultMargin, marginBottom = defaultMargin } = props;
  return /* @__PURE__ */ jsx("hr", { className: classNames("mx-n3", "mx-sm-n4", `mt-${marginTop}`, `mb-${marginBottom}`) });
}
function FlashModalFooter(props) {
  const { modalId, close, dismiss, confirm } = props, { t } = useTranslation(), { windowIsMobile } = useWindowSize(), dismissBtnProps = buildButtonProps(`${modalId}-dismiss-btn`, dismiss, {
    onClick: close,
    children: t("MODAL:DISMISS"),
    color: "tertiary",
    isBlock: windowIsMobile
  }), confirmBtnProps = buildButtonProps(`${modalId}-confirm-btn`, confirm, {
    onClick: noOp,
    children: t("MODAL:CONFIRM"),
    color: "primary",
    isBlock: windowIsMobile
  });
  return /* @__PURE__ */ jsxs("div", { className: "d-flex flex-column-reverse flex-sm-row gap-2 p-3 p-sm-4", children: [
    /* @__PURE__ */ jsx(FlashButton, { ...dismissBtnProps }),
    (confirm == null ? void 0 : confirm.onClick) && /* @__PURE__ */ jsx(FlashButton, { ...confirmBtnProps })
  ] });
}
function buildButtonProps(id, providedProps = {}, defaultProps) {
  return defaults$1({ id }, providedProps, defaultProps);
}
export {
  FlashModalFooter,
  FlashModalHorizontalRule,
  FlashModalTitle
};
//# sourceMappingURL=FlashModalUtils.js.map
